import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const DataCollectionContext = createContext();

export const DataCollectionProvider = ({ children }) => {
  const [activeDevices, setActiveDevices] = useState([]);

  const updateActiveDevices = (devices) => {
    setActiveDevices(devices);
  };

  return (
    <DataCollectionContext.Provider value={{ activeDevices, updateActiveDevices }}>
      {children}
    </DataCollectionContext.Provider>
  );
};

DataCollectionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDataCollection = () => useContext(DataCollectionContext);
